<div #menuButton class="menu-button" [class.open]="isOpen">
    @if (openOnHover) {
        <cerrix-icon
            [icon]="icon"
            [size]="iconSize"
            [color]="iconColor"
            [attr.data-uiid]="dataUiid + '-togglemenu-button'"
            (mouseenter)="openMenu()"
            (mouseleave)="closeMenu()"
        ></cerrix-icon>
    } @else {
        <cerrix-icon
            [icon]="icon"
            [size]="iconSize"
            [color]="iconColor"
            [attr.data-uiid]="dataUiid + '-togglemenu-button'"
            (click)="toggleMenu()"
        ></cerrix-icon>
    }
</div>
<div
    #menuList
    class="cerrix-drop-menu-list"
    [class.open]="isOpen"
    [class.fixed]="dropMenuOnTop"
    [class.list-reverse]="listReverse"
    [class.list-item-reverse]="listItemReverse"
    [class]="[dropPosition, dropCorner]"
>
    <ng-content></ng-content>
</div>
